import { ElectronAPI } from '../base/ElectronAPI';
import { IPCEventType } from '../base/types';

export class FeatureFlagsAPI extends ElectronAPI {
  updateFeatureFlags(flags: string) {
    this.notifyContextKit(IPCEventType.setFeatureFlags, { flags });
    this.ipcRenderer.send(IPCEventType.setFeatureFlags, { flags });
  }
}
